(ns rothko.theme.sandi.footer)

(def main
  {:primary
   {}

   :fixed
   {:bottom 0
    :position :fixed
    :width "100%"}})
